import DashboardLayout from '../components/Dashboard/Layout/DashboardLayout.vue'
// GeneralViews
import NotFound from '../components/GeneralViews/NotFoundPage.vue'

// Admin pages
import Login from 'src/components/Dashboard/Views/Login.vue'

import Plants from 'src/components/Dashboard/Views/Plants/Plants.vue'
import PlantInfo from 'src/components/Dashboard/Views/Plants/PlantInfo.vue'
import PlantPhoto from 'src/components/Dashboard/Views/Plants/PlantPhoto.vue'

import Diseases from 'src/components/Dashboard/Views/Diseases/Diseases.vue'
import DiseaseInfo from 'src/components/Dashboard/Views/Diseases/DiseaseInfo.vue'

import Articles from 'src/components/Dashboard/Views/Articles/Articles.vue'
import ArticleInfo from 'src/components/Dashboard/Views/Articles/ArticleInfo.vue'

import Suggestions from 'src/components/Dashboard/Views/Suggestions/Suggestions.vue'
import SuggestionInfo from 'src/components/Dashboard/Views/Suggestions/SuggestionInfo.vue'

import Auth from '../middleware/Auth'

const routes = [
    {
        path: '/login',
        name: 'login',
        component: Login
    },
    {
        path: '/',
        redirect: "/plants",
        component: DashboardLayout,
        children: [

            {
                path: 'plants',
                name: 'plants',
                component: Plants,
                meta: {
                    middleware: [Auth]
                },
            },

            {
                path: 'plants/:id',
                name: 'plant-info',
                component: PlantInfo,
                meta: {
                    middleware: [Auth]
                },
            },

            {
                path: 'plants/:id/photo',
                name: 'plant-photo',
                component: PlantPhoto,
                meta: {
                    middleware: [Auth]
                },
            },

            {
                path: 'diseases',
                name: 'diseases',
                component: Diseases,
                meta: {
                    middleware: [Auth]
                },
            },

            {
                path: 'diseases/create',
                name: 'diseases-create',
                component: DiseaseInfo,
                meta: {
                    middleware: [Auth]
                },
            },

            {
                path: 'diseases/:id',
                name: 'diseases-info',
                component: DiseaseInfo,
                meta: {
                    middleware: [Auth]
                },
            },

            {
                path: 'articles',
                name: 'articles',
                component: Articles,
                meta: {
                    middleware: [Auth]
                },
            },

            {
                path: 'articles/create',
                name: 'articles-create',
                component: ArticleInfo,
                meta: {
                    middleware: [Auth]
                },
            },

            {
                path: 'articles/:id',
                name: 'articles-info',
                component: ArticleInfo,
                meta: {
                    middleware: [Auth]
                },
            },

            {
                path: 'suggestions',
                name: 'suggestions',
                component: Suggestions,
                meta: {
                    middleware: [Auth]
                },
            },

            {
                path: 'suggestions/:id',
                name: 'suggestion-info',
                component: SuggestionInfo,
                meta: {
                    middleware: [Auth]
                },
            },

        ]
    },
    {path: '*', component: NotFound}
];

export default routes



// WEBPACK FOOTER //
// ./src/routes/routes.js